import {
  GhostButton,
  PrimaryButton,
  SecondaryTopNav,
} from "@certn/cascadia-react";
import { t } from "i18next";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { UnifiedIntegrationContext } from "../UnifiedIntegrationContext";

interface Props {
  onComplete?: () => void;
  isDisabled?: boolean;
  submitting?: boolean;
}

export function UnifiedIntegrationStepHeader({
  onComplete,
  isDisabled,
  submitting,
}: Props) {
  const navigate = useNavigate();
  const { goToPrevStep, currentStep } = useContext(UnifiedIntegrationContext);

  const cancel = () => {
    navigate("/settings/ats-integrations");
  };

  const steps = [
    { buttonLabel: t("Connect account") },
    { buttonLabel: t("Complete setup") },
  ];

  return (
    <SecondaryTopNav
      testID="unified-integration-setup-top-nav"
      leftIcon={currentStep === 0 ? "close" : "arrow_back"}
      onleftIconOnPress={currentStep === 0 ? cancel : goToPrevStep}
    >
      {currentStep > 0 && (
        <GhostButton
          onPress={cancel}
          testID="unified-integration-setup-top-nav-cancel-button"
        >
          {t("Cancel")}
        </GhostButton>
      )}
      <PrimaryButton
        onPress={onComplete}
        isDisabled={isDisabled}
        isLoading={submitting}
        testID="unified-integration-setup-top-nav-next-step-button"
      >
        {steps[currentStep].buttonLabel}
      </PrimaryButton>
    </SecondaryTopNav>
  );
}
